//GeneratorFlag:[NoChange]
import ProcessGroup from './process-group';
import ProcessGroupFilter from './process-group-filter';

export default {ProcessGroup, ProcessGroupFilter}
export{ProcessGroup, ProcessGroupFilter}